import { render, staticRenderFns } from "./vip2.vue?vue&type=template&id=47d51508&"
import script from "./vip2.vue?vue&type=script&lang=js&"
export * from "./vip2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports